export class ViewingSessionModel{
    viewingSessionId:string;
    constructor(){}
 }